import React from "react"
import { AppAntSwitch } from "@components"
import { repricingPass } from "@signals"
import { showPassDecisions } from "Pages/AnalyzersV2/@signals"

// "Repricing decisions": only with a pass open, on by default; off hides the marks and their legend, not the prices
// (CU-869fmm949, criterion 3)
export default function ToggleDecisions() {
	if (!repricingPass.value) return null
	return <AppAntSwitch
		falseText="Hide decisions"
		trueText="Show decisions"
		checked={showPassDecisions.value}
		onChange={() => showPassDecisions.value = !showPassDecisions.value}
	/>
}
